
import Vue, { PropType } from 'vue'
import { getRiskScoreColor } from '../utils'

const defaultScores = [4, 7]

const ScoreLimit = Vue.extend({
    name: 'ScoreLimit',
    props: {
        label: {
            type: String,
            default: '<Score limits>',
        },
        value: {
            type: [Number, Array as PropType<number[]>],
            default: () => defaultScores,
        },
        range: {
            type: Array as PropType<number[]>,
        },
    },
    computed: {
        isRange() {
            return Array.isArray(this.value)
        },
    },
    methods: {
        getRiskScoreColor(score: number, medium: number, high: number) {
            return getRiskScoreColor(score, medium, high)
        },
    },
    data() {
        let value = this.value
        if (Array.isArray(value)) value = value.map((v, index) => v || defaultScores[index])

        return { scoreLimit: value }
    },
})

export default ScoreLimit
